<div
  class="component-container sm:min-w-[25rem] md:min-w-[54rem] h-full flex flex-col justify-center">
  <div class="heading">
    Edit Data
  </div>
  <hr>
  <div class="content">
    <div class="row flex flex-row justify-between items-center">
      <div class="label w-1/2">
        Date
      </div>
      <app-date-picker
        class="date-picker-input w-1/2"
        [parentFormGroup]="form"
        controlName="recordedOn"
        [max]="maxDate"
        [error]="errorMessages['recordedOn']"
        (checkForErrors)="checkForErrors($event)"
        placeholder="Select a date"
        type="small"
      ></app-date-picker>
    </div>

    <div
      class="measurement-inputs"
    >
      <div *ngIf="metricValue['height']">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
           {{ metricValue['height']?.name}}
          </div>
          <app-height-input
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="height"
            [error]="errorMessages['height']"
            type="small"
          ></app-height-input>
        </div>
      </div>

      <div *ngIf="metricValue['weight']">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{ metricValue['weight']?.name}}
          </div>
          <app-number-input
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="weight"
            [error]="errorMessages['weight']"
            placeholder="000.00"
            type="small"
          ></app-number-input>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="action-panel flex flex-row justify-end items-center">
    <div
      class="icon-panel-submit w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleSubmit()"
    >
      <app-icon icon="check" cssClass="icon-panel-icon"></app-icon>
    </div>
    <div
      class="icon-panel-cancel w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleCancel()"
    >
      <app-icon icon="close" cssClass="icon-panel-icon"></app-icon>
    </div>
  </div>
</div>
